// cart-drawer Incart-upsell js
class incartUpsell extends Carousel {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addDatalayerEvent()
  }


  addDatalayerEvent(){
    this.querySelectorAll(".quick-add__submit").forEach((eachProduct) => {
      eachProduct.addEventListener('click', () => {

        const cartItems = document.querySelectorAll("#CartDrawer-CartItems tr");
        if (!cartItems.length) return;
        
        const lastAddedProduct = cartItems[0]?.querySelector(".cart-item__details a")?.textContent || '';
        const cartDrawer = document.querySelector("cart-drawer .drawer__inner");
        const spinnerContainer = cartDrawer?.querySelector(".cart-drawer__spinner-wrapper");
        spinnerContainer?.classList.remove('hide-loader');

        const clevertapData = {
          Previous_Product_Added_To_Cart: lastAddedProduct,
          Previous_Page: document.referrer,
          Landing_Page: eachProduct.dataset.productLink,
          Custom_Upsell_PDP_Name: eachProduct.dataset.productName,
          Custom_Upsell_PDP_Price: eachProduct.dataset.productPrice,
          Custom_Upsell_PDP_Qty: 1
        }
      
        dataLayer.push({
          event: "Custom_Upsell",
          Previous_Product_Added_To_Cart: lastAddedProduct,
          Previous_Page: document.referrer,
          Landing_Page: eachProduct.dataset.productLink,
          Custom_Upsell_PDP_Name: eachProduct.dataset.productName,
          Custom_Upsell_PDP_Price: eachProduct.dataset.productPrice,
          Custom_Upsell_PDP_Qty: 1,
          clevertap: clevertapData
        });
      })
    })
  }
}

customElements.define('incart-upsell', incartUpsell);